module.exports = __webpack_public_path__ + "img/au-icon-business-name.15187cce.svg";